import { render, staticRenderFns } from "./MetaMetricsSettings.vue?vue&type=template&id=c336c836&scoped=true"
import script from "./MetaMetricsSettings.vue?vue&type=script&lang=js"
export * from "./MetaMetricsSettings.vue?vue&type=script&lang=js"
import style0 from "./MetaMetricsSettings.vue?vue&type=style&index=0&id=c336c836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c336c836",
  null
  
)

export default component.exports